import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { Provider } from 'react-redux';
import store from './redux/store';

import { I18nProvider } from '@lingui/react';
import i18n from './i18n';

// Clean up old expired local storage keys
for (let [key, value] of Object.entries(localStorage)) {
  const m = key.match(/game-uuid-(\w{6})-expire/);
  if (m) {
    if (Date.now() > value) {
      localStorage.removeItem(`game-uuid-${m[1]}`);
      localStorage.removeItem(key);
    }
  }
}

ReactDOM.render(
  <I18nProvider i18n={i18n}>
    <Provider store={store}>
      <App />
    </Provider>
  </I18nProvider>,
  document.getElementById('root'));
